import { createFileRoute } from '@tanstack/react-router'
import { ReferralOnboardingWizard } from '@/features/referrals/referral-onboarding-wizard'
import { requireActiveSubscription } from '@/lib/middleware'

export const Route = createFileRoute(
  '/_authenticated/_organization/referrals/$referralId'
)({
  beforeLoad: async () => requireActiveSubscription(),
  component: ReferralOnboardingWizard,
})
